// Timber Trail Lodge booking strategy (ResBook calendar, property 5271).
//
// The link lands on the lodge's ResBook calendar opened at the arrival
// date: `&sqlStartDate=<Y-n-j>` (unpadded, the shape ResBook's own
// calendar script sends) shows nine nights of every room row from that
// date, and the camper ticks the nights on their room row and books.
//
// A deeper link exists — `reservation=new&av_sel_arr=[…]` opens booking
// step 1 with the room and nights already selected — but it skips the
// calendar's guards: it quoted a Pending night and a single weekend night
// on an ensuite room, both of which the calendar refuses. A stale alert
// would drop the camper into a quote the lodge will not honour, so the
// calendar landing is the emitted depth.

import { format } from "date-fns";

export default {
  buildBookingUrl({ site, arrivalDate }) {
    const url = new URL(site.reserveUrl);
    url.searchParams.set("sqlStartDate", format(arrivalDate, "yyyy-M-d"));
    return url.toString();
  },

  buildPreviewUrl(site) {
    return site.reserveUrl;
  },

  describeBookingInputs() {
    return {
      inputs: {
        arrivalDate: {
          status: "required",
          notes:
            "Encoded as &sqlStartDate=<Y-n-j>; the calendar opens on that night.",
        },
        departureDate: {
          status: "ignored",
          notes:
            "The calendar has no departure input; the camper ticks each night on the room row.",
        },
        ref: {
          status: "ignored",
          notes:
            "The calendar shows every room row; the camper picks the room type there.",
        },
        partySize: {
          status: "ignored",
          defaultValue: 2,
          notes:
            "Guests are set on booking step 1, after the calendar; it defaults to 2 adults.",
        },
      },
    };
  },
};
